import axiosInstance from './axiosInstance';

export const fetchObjetivos = async () => {
  return await axiosInstance.get('/api/deportistas/objetivos/');
};

export const completarPerfil = async (uid, data) => {
  return await axiosInstance.post(`/api/auth/${uid}/perfil/`, data);
};

export const editarPerfil = async (uid, data) => {
  return await axiosInstance.patch(`/api/auth/${uid}/perfil/`, data)
};

export const fetchBloques = async (uid, date) => {
  return await axiosInstance.get(
    `/api/deportistas/${uid}/bloques/asignados/${date}/`
  );
};

export const asociarObjetivo = async (uid, data) => {
  return await axiosInstance.post(`/api/deportistas/${uid}/objetivos`, data);
};

export const completarEncuesta = async (
  uid,
  id_encuesta_deportista,
  fecha,
  data
) => {
  return await axiosInstance.post(
    `/api/deportistas/${uid}/encuestas/${id_encuesta_deportista}/${fecha}/responder`,
    data
  );
};

export const fetchEncuesta = async (uid, fecha) => {
  return await axiosInstance.get(`/api/deportistas/${uid}/encuestas/${fecha}/`);
};

export const getUserInfo = async (uid) => {
  return await axiosInstance.get(`api/auth/${uid}/perfil/`);
};

export const getUserActivity = async (uid) => {
  return await axiosInstance.get(`api/deportistas/${uid}/actividad/`);
};

export const getTrainerInfo = async (uid) => {
  return await axiosInstance.get(`api/entrenadores/${uid}/`);
};

export const getTrainerList = async () => {
  return await axiosInstance.get(`api/entrenadores/`);
};

export const getCargasDetalle = async (uid, fecha) => {
  return await axiosInstance.get(`api/deportistas/${uid}/cargas/${fecha}`);
};

export const getDetalleEjercicio = async (uid, ejercicio_id) => {
  return await axiosInstance.get(
    `api/deportistas/${uid}/ejercicios/${ejercicio_id}`
  );
};

export const actualizarBloque = async (data) => {
  return await axiosInstance.patch(`api/deportistas/ejercicio/`, data);
};

export const getMaximos = async (uid) => {
  return await axiosInstance.get(`api/deportistas/${uid}/cargas/maximos/`);
};

export const cancelarEntrenamiento = async () => {
  return await axiosInstance.post(`api/deportistas/desasociar/entrenador/`);
};

export const solicitarEntrenamiento = async (uid) => {
  return await axiosInstance.post(`api/deportistas/solicitar/entrenador/`, {
    entrenador_id: uid,
  });
};
